/**
 * Radius Tokens - Corner radii scale
 */

export const radii = {
  none: { value: '0px' },
  xs: { value: '2px' },
  s: { value: '4px' },
  m: { value: '6px' },
  l: { value: '8px' },
  xl: { value: '12px' },
  '2xl': { value: '16px' },
  full: { value: '999px' },
};
